import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from "rxjs";
import { ToasterService } from "../shared/toaster/toaster.service";
import { inject } from "@angular/core";

export const HttpErrorInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const toasterService = inject(ToasterService);
  const authToken = 'TOKEN';

  let errorMessage = '';

  const authReq = req.clone({
    // setHeaders: {
    //   Authorization: `Bearer ${authToken}`
    // }
  })



  return next(authReq).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          errorMessage = `Unauthorized request:', ${err}`;
        } if (err.status === 404) {
          errorMessage = 'Server not found';
        } if (err.status === 400) {
          errorMessage = `${err.error?.detail ||'Not found' }`;
        } else {
          errorMessage = `HTTP error: , ${err.message ||'Request fail' }`;
        }
      } else {
        errorMessage = 'An error occurred';
      }

      toasterService.showToast('error', errorMessage);
      console.error(errorMessage);

      return throwError(() => new Error(err));
    })
  );

};
